import {
    ProductSlider,
    ProductSliderProps
} from "@/components/Product/ProductSlider/productSlider.container";

type RelatedProductsProps = {
    productSliderProps: ProductSliderProps;
};

export const RelatedProducts = ({
    productSliderProps
}: RelatedProductsProps) => {
    return (
        <>
            <hr />
            <ProductSlider {...productSliderProps} />
        </>
    );
};
